/** Clears stale app workers in development and registers offline support in production. */
export const registerServiceWorker = (): void => {
  if (!("serviceWorker" in navigator)) return;

  if (import.meta.env.DEV) {
    // A production preview can leave our cache-first worker controlling the same dev origin.
    void navigator.serviceWorker.getRegistrations().then(async (registrations) => {
      const isCrmWorker = (url: string) => new URL(url).pathname === `${import.meta.env.BASE_URL}sw.js`;
      const controlled = navigator.serviceWorker.controller && isCrmWorker(navigator.serviceWorker.controller.scriptURL);
      await Promise.all(registrations.filter((registration) =>
        [registration.active, registration.waiting, registration.installing].some((worker) => worker && isCrmWorker(worker.scriptURL)),
      ).map((registration) => registration.unregister()));
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.filter((name) => name.startsWith("tripbox-") || name.startsWith("crm-")).map((name) => caches.delete(name)));
      }
      if (controlled) window.location.reload();
    }).catch((error: unknown) => console.error("Unable to clear development worker cache", error));
    return;
  }

  if (!import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL })
      .catch((error: unknown) => console.error("Unable to register the workspace service worker", error));
  });
};
